module.exports = __webpack_public_path__ + "static/media/why-imgm.8d08122c.png";